require('./bootstrap');
import Vue from 'vue';

import VueGoogleMap from 'vuejs-google-maps'
import 'vuejs-google-maps/dist/vuejs-google-maps.css'
Vue.use(VueGoogleMap, {
    load: {
        apiKey: 'AIzaSyAJlmXmjsZGNK4CxbL4sJcZLOYlOcDmNI0',
        libraries: [/* rest of libraries */]
    }
})

import filter from './views/properties/filter';
import list from './views/properties/list';
import map from './views/properties/list_map';

window.vue_properties = new Vue({
    data(){
        return {
            properties: [],
            filter: {
                district: '',
                city: '',
                when_start: '',
                when_end: '',
                booking_type: 1,
                how_long: '',
                type: [],
                equipment: [],
                service: [],
                price_min: '',
                price_max: '',
                rate: 0,
                name: ''
            }
        };
    },
    components: {
        'filter-view': filter,
        'list-view': list,
        'map-view': map
    },
    updated(){
        $('#properties-list .list-container').css('height', $('#properties-filters').outerHeight(true));
        $('#properties-map #map').css('height', $('#properties-filters').outerHeight(true));
    },
    methods:{
        setParams(params){
            this.filter.base_category = params.base_category ? params.base_category : this.filter.base_category;
            this.filter.district = params.district ? params.district : this.filter.district;
            this.filter.city = params.city ? params.city : this.filter.city;
            this.filter.when_start = params.when_start ? params.when_start : this.filter.when_start;
            this.filter.when_end = params.when_end ? params.when_end : this.filter.when_end;
            this.filter.time_from = params.time_from ? params.time_from : this.filter.time_from;
            this.filter.time_to = params.time_to ? params.time_to : this.filter.time_to;
            this.filter.booking_type = params.booking_type ? params.booking_type : this.filter.booking_type;
            this.filter.type = params.type ? params.type : this.filter.type;
            this.filter.equipment = params.equipment ? params.equipment : this.filter.equipment;
            this.filter.service = params.service ? params.service : this.filter.service;
            this.filter.price_min = params.price_min != undefined ? params.price_min : this.filter.price_min;
            this.filter.price_max = params.price_max != undefined ? params.price_max : this.filter.price_max;
            this.filter.rate = params.rate ? params.rate : this.filter.rate;
            this.filter.sort = params.sort ? params.sort : this.filter.sort;
            this.filter.name = params.name != undefined ? params.name : this.filter.name;

            history.pushState({}, null, window.location.href.split('?')[0] + '?' + $.param(this.filter));

            this.getProperties();
        },

        getParam(name){
            return this.filter[name];
        },
        getProperties(){
            let _self = this;
            axios(Laravel.baseApiUrl + '/properties', {
                params: this.filter
            })
            .then(function(response){
                if(response.data && response.data.length > 0){
                    _self.properties = response.data;
                }else{
                    _self.properties = [];
                }
                _self.$forceUpdate();
            });
        }
    }
}).$mount('#list-search-vue-app');
